<template>
  <b-modal
    ref="modal"
    size="lg"
    hide-header
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    centered
  >
    <div class="lock-overlay__card">
      <i class="fas fa-fingerprint lock-overlay__icone"></i>
      <h4 class="lock-overlay__titulo">Tela bloqueada</h4>
      <p class="lock-overlay__texto">
        Informe o código do seu aplicativo autenticador para continuar.
      </p>

      <FAInput
        :key="inputKey"
        class="lock-overlay__input"
        @codigo:atualizado="codigo = $event"
        @enter="desbloquear"
      />

      <button type="button" class="lock-overlay__sair" @click="sair">
        <i class="fas fa-sign-out-alt mr-1"></i> Sair
      </button>
    </div>
  </b-modal>
</template>

<script>
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";
import { LOGOUT } from "@/core/services/store/auth.module";
import { mapGetters } from "vuex";
import FAInput from "../../pages/auth/login_pages/2FAInput.vue";

// WEL-5193: após esse número de códigos errados seguidos, desloga
// automaticamente em vez de deixar tentar de novo.
const MAX_TENTATIVAS = 3;

export default {
  name: "LockOverlay",
  components: { FAInput },
  data() {
    return {
      codigo: "",
      desbloqueando: false,
      tentativasErradas: 0,
      inputKey: 0
    };
  },
  computed: {
    ...mapGetters(["currentUserPersonalInfo", "telaBloqueada"])
  },
  watch: {
    telaBloqueada: {
      immediate: true,
      handler(bloqueada) {
        this.$nextTick(() => {
          if (bloqueada) {
            this.$refs.modal.show();
          } else {
            this.$refs.modal.hide();
          }
        });
      }
    }
  },
  methods: {
    desbloquear() {
      if (!this.codigo || this.desbloqueando) {
        return;
      }

      this.desbloqueando = true;

      ApiService.post("desbloquear-tela", { codigo: this.codigo })
        .then(() => {
          // Reload em vez de so virar a flag: enquanto bloqueada, varias
          // telas tiveram chamadas rejeitadas (423) e podem ter ficado com
          // dado parcial ou carregando pra sempre -- recarregar garante que
          // tudo volte a bater com o estado real em vez de ficar quebrado
          // ate a pessoa dar F5 na mao.
          window.location.reload();
        })
        .catch(() => {
          this.codigo = "";
          this.inputKey++; // remonta o FAInput e limpa as caixas
          this.tentativasErradas++;

          if (this.tentativasErradas >= MAX_TENTATIVAS) {
            this.deslogarPorTentativas();
            return;
          }

          Swal.fire({
            title: "MENSAGEM",
            text: "O código informado é inválido, tente novamente.",
            icon: "error",
            heightAuto: false
          });
        })
        .finally(() => {
          this.desbloqueando = false;
        });
    },

    // Logout direto, sem o dialog de confirmação do botão Sair manual — é
    // o sistema decidindo por excesso de tentativas, não o usuário.
    deslogarPorTentativas() {
      Swal.fire({
        title: "MENSAGEM",
        text: "Muitas tentativas incorretas. Sua sessão foi encerrada por segurança.",
        icon: "error",
        heightAuto: false
      }).then(() => {
        this.$store.dispatch(LOGOUT, true).then(() => {
          this.$router.push({ name: "login" });
        });
      });
    },

    sair() {
      this.$bus.$emit("logout:usuario");
    }
  }
};
</script>

<style lang="scss" scoped>
.lock-overlay__card {
  text-align: center;
  padding: 1rem 0.5rem;
}

.lock-overlay__icone {
  font-size: 3.5rem;
  color: #462181;
  margin-bottom: 1rem;
}

.lock-overlay__titulo {
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.lock-overlay__texto {
  color: #6a6579;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
}

.lock-overlay__input {
  margin-bottom: 1.5rem;
}

.lock-overlay__sair {
  border: none;
  background: none;
  color: #837f95;
  font-size: 0.85rem;
  cursor: pointer;

  &:hover {
    color: #462181;
    text-decoration: underline;
  }
}
</style>
